import { Select, Space, Tabs } from "antd";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import useTabKey from "../hooks/useTabKey";
import { getUserRole } from "../services/api-server/roles_permissions";
import Emitter from "../utils/emitter";
import { getCrudaClass } from "../utils/lookup_list";
import { HomeContext } from "./Home";
import ModuleConfig from "./ModuleConfig";
import TenantDetail from "./TenantDetail";

const tabList = [
	{ label: "Tenant detail", key: "tenant-detail" },
	{ label: "Module configuration", key: "module-configuration" },
];

function TenantConfig({ params }: any) {
	const location = useLocation();
	const { currentTenantData, currentTenantKey, userInfo, setUserRole }: any =
		useContext(HomeContext);

	const [allTenants, setAllTenants] = useState<any[]>([]);
	const [currentTenant, setCurrentTenant] = useState<any>(null);

	const { tabKey, handleTabChange } = useTabKey(
		sessionStorage.getItem("main-tabkey") || "module-configuration"
	);

	const tabContent = () => {
		switch (tabKey) {
			case "tenant-detail":
				return (
					<TenantDetail
						currentTenant={currentTenant}
						setCurrentTenant={setCurrentTenant}
						onTenantSave={handleTenantSave}
					/>
				);
			case "module-configuration":
				return (
					<ModuleConfig
						currentTenant={currentTenant}
						setCurrentTenant={setCurrentTenant}
					/>
				);
		}
	};

	const findCurrentTenant = (tenant_list: any) => {
		if (tenant_list.length > 0) {
			setCurrentTenant(
				location.state
					? tenant_list.find(
							(tenant: any) => tenant.role_key === location.state.role_key
						)
					: tenant_list.find(
							(tenant: any) => tenant.role_key === currentTenantData.role_key
						)
			);
		}
	};

	const fetchTenants = async () => {
		try {
			Emitter.emit("loading", { name: "tenant-config", isLoading: true });
			const tenantCruda = await getCrudaClass("tenant");
			const { tableData }: any = await tenantCruda.getLookupItem(
				"tenant",
				currentTenantKey
			);
			console.log("tenant_list: ", tableData);
			setAllTenants(tableData);
			findCurrentTenant(tableData);
			Emitter.emit("loading", { name: "tenant-config", isLoading: false });
		} catch (error) {
			console.error("Error fetching tenants:", error);
			setAllTenants([]);
			Emitter.emit("loading", { name: "tenant-config", isLoading: false });
		}
	};

	useEffect(() => {
		fetchTenants();
	}, [currentTenantKey]);

	// Refresh user role after tenant changes (in case user was added/removed from tenant)
	const refreshUserRole = async () => {
		if (currentTenantKey && userInfo?.user?.email && setUserRole) {
			try {
				const userRoleData = await getUserRole(
					currentTenantKey,
					userInfo.user.email
				);
				setUserRole(userRoleData || []);
			} catch (error) {
				console.error("Error refreshing user role:", error);
			}
		}
	};

	// Handle tenant save - refresh user role if current user was affected
	const handleTenantSave = async () => {
		// Refresh user role after tenant assignment changes
		await refreshUserRole();
	};

	return (
		<div className="generic-container">
			<Space direction="vertical">
				<Select
					getPopupContainer={(trigger: any) => trigger.parentNode}
					className="title-selector"
					style={{
						fontSize: "20px",
						fontWeight: "600",
						color: "rgba(255, 255, 255, 0.85)",
						width: "auto",
					}}
					options={allTenants}
					value={currentTenant?.role_key}
					dropdownStyle={{ minWidth: "100%", width: "auto" }}
					fieldNames={{
						label: "role_key",
						value: "role_key",
					}}
					onChange={(key: any) => {
						console.log("Change tenant", key);
						const _tenant = allTenants.find(
							(tenant: any) => tenant.role_key === key
						);
						setCurrentTenant(_tenant);
					}}
				/>

				<Tabs
					activeKey={tabKey}
					onChange={(key: any) => {
						handleTabChange(key);
					}}
					items={tabList}
				/>
			</Space>
			<div
				style={{
					flex: "1",
					display: "flex",
					flexDirection: "row",
					gap: "20px",
					maxHeight: "100%",
					overflow: "auto",
				}}
			>
				{tabContent()}
			</div>
		</div>
	);
}

export default TenantConfig;
